<style>
	p.text-large{
		margin-bottom: 0;
		font-weight: 300;
		font-size: 1.1em;
	}
</style>
<template>
	<div>
		<h2 class="mw-h1">Request</h2>
		<v-card class="pa-3">
			<v-tabs right
			background-color="white"
			color="black"
			v-model="tab">
				<v-tabs-slider></v-tabs-slider>
				<v-tab href="#info">Info</v-tab>
				<v-tab href="#segments">Segments</v-tab>
				<v-tab href="#additionalCosts">Additional Costs</v-tab>
				<v-tab href="#quote">Quote</v-tab>
				<v-tab-item value="info">
						
					<v-row>
						<v-col cols="12">
							<span class="overline">Our Reference</span>
							<v-text-field class="mt-2 mb-0" hide-details v-model="request.reference" filled rounded dense></v-text-field>
						</v-col>
					</v-row>
					<v-row>
						<v-col cols="12" sm="8">
							<span class="overline">Request Title</span>
							<p class="text-large">{{request.title}}</p>
						</v-col>
						<v-col cols="12" sm="4">
							<span class="overline">Client ref.</span>
							<p class="text-large">{{request.clientReference}}</p>
						</v-col>
					</v-row>
					<v-row v-if="request.description">
						<v-col cols="12">
							<span class="overline">Description</span>
							<p class="text-large">{{request.description}}</p>
						</v-col>
					</v-row>
					<v-row v-if="request.created">
						<v-col cols="12">
							<span class="overline">Submitted</span>
							<p class="text-large">{{request.created.toDate() | moment('MMMM Do YYYY, h:mm:ss a')}}</p>
						</v-col>
					</v-row>
					<v-row>
						<v-col cols="6" v-if="organisation">
							<span class="overline">Organisation</span> 
							<p class="text-large">{{organisation.name}} <v-btn icon link v-bind:href="'/edit/organisations/' + organisation.id "><v-icon>mdi-link</v-icon></v-btn></p>
						</v-col>
						<v-col cols="6">
							<span class="overline">Department</span>
							<p class="text-large">{{request.department}}</p>
						</v-col>
					</v-row>
					<v-row v-if="submittingUser">
						<v-col cols="4">
							<span class="overline">Client</span>
							<p class="text-large">{{submittingUser.displayName}}<v-btn icon link v-bind:href="'/edit/clients/' + submittingUser.id "><v-icon>mdi-link</v-icon></v-btn></p>
						</v-col>
						<v-col cols="4">
							<span class="overline">Email</span>
							<p class="text-large">{{submittingUser.email}}</p>
						</v-col>
						<v-col cols="4">
							<span class="overline">Phone</span>
							<p class="text-large">{{submittingUser.phone}}</p>
						</v-col>
					</v-row>
					<v-row>
						<v-col>
							<span class="overline">MW Contacts</span>
							<v-select
								dense rounded filled
								multiple
								v-model="mwContacts"
								:items="admins"
								item-value="id"
								item-text="displayName"
							></v-select>							
						</v-col>
					</v-row>
					<v-row>
						<v-col>
							<span class="overline">Start Date</span>
							<DateTimeField 
							:object="request"
							type="date"
							objectKey="startDate" 
							:initialValue="request.startDate"  
							v-bind="{ rounded: true, filled: true, dense: true }"
							></DateTimeField>
						</v-col>
						<v-col>
							<span class="overline">End Date</span>
							<DateTimeField 
							:object="request"
							type="date"
							objectKey="endDate" 
							:initialValue="request.endDate"  
							v-bind="{ rounded: true, filled: true, dense: true }"
							></DateTimeField>
						</v-col>
					</v-row>
					<v-row>
						<v-col>
							<span class="overline">Deliverables</span>
							<AddManyTable :items="deliverables" :columns="deliverableColumns"></AddManyTable>
						</v-col>
					</v-row>
					<v-row>
						<v-col>
							<span class="overline">Status</span>
							<v-select dense rounded filled v-model="request.status" :items="['new', 'paused', 'quoted', 'project-started', 'archived', 'confirmed']"></v-select>
							<p class="text-right">
								<v-btn v-if="request.project" small color="primary" dark link :href="'/edit/projects/'+request.project">Go to project</v-btn>
							</p>
						</v-col>
					</v-row>
				</v-tab-item>

				<v-tab-item value="segments">
					<v-row>
						<v-col>
						<MwDataTable
							:allowHighlight="false"
							:editable="true"
							:showSearch="false"
							id="segmentTable"
							:allowExport="false"
							itemKey="index"
							:columns="segmentColumns"
							:rows="request.segments"
							v-on:deleteSegment="deleteSegment"
						>
						</MwDataTable>
						<p class="text-right">
							<v-btn color="primary" @click="addSegment">Add Segment</v-btn>
						</p>
						</v-col>
					</v-row>
				</v-tab-item>
				<v-tab-item value="additionalCosts">
					<v-row>
						<v-col>
							<AddManyTable :items="additionalCosts" :columns="additionalCostsColumns"></AddManyTable>					
						</v-col>
					</v-row>
				</v-tab-item>
				<v-tab-item value="quote">

				<v-row>
					<v-col>
						<v-select dense rounded filled v-model="request.currency" :items="['£', '$', '€']"></v-select>
						<Quote :request="request" :contract="contract"></Quote>
					</v-col>
				</v-row>

				</v-tab-item>
			</v-tabs>
			<p>
					<v-dialog v-model="dialog">
						<template v-slot:activator="{ on }">
							<v-btn color="accent" dark v-on="on" class="mr-2">
								Convert to Project
							</v-btn>
						</template>

						<v-card>
							<v-card-title>Convert to Project</v-card-title>
							<v-card-text>
								<NewProjectForm :prefill="newProjectFields" v-on:created="requestConverted"></NewProjectForm>								
							</v-card-text>
							<v-divider></v-divider>

						</v-card>
					</v-dialog>			
				<v-btn @click="alertClientQuote" color="primary" class="mr-2" dark>Notify Client</v-btn>
				<v-btn color="green" dark @click="saveRequest">Save</v-btn>
			</p>
		</v-card>
	</div>
</template>

<script>
	import Quote from "../tools/Quote.vue";
	import MwDataTable from "../tools/MwDataTable.vue";	
	import DateTimeField from "../tools/DateTimeField.vue";
	import AddManyTable from "../tools/AddManyTable.vue";
	import NewProjectForm from "../forms/NewProjectForm.vue";
	import {formatDateTime} from "../../assets/utilities.js"
	import Vue from "vue";
	import Vuex from 'vuex';
	
	export default	{
		name: "EditRequest", 
		props: {
			request: {type: Object },
		},
		components: {
			MwDataTable: MwDataTable,
			Quote: Quote,
			NewProjectForm: NewProjectForm,
			DateTimeField: DateTimeField,
			AddManyTable: AddManyTable
		},
		data: () => {
			return {
				tab: "info",
				additionalCosts: [],
				mwContacts: [],
				deliverables: [], 
				dialog: false,
			}
		},
		computed: {
			...Vuex.mapState({
				view: (state) => state.auth.view,
				user: (state) => state.auth.user,
				admins: (state) => state[state.auth.view].admins,
				clients: (state) => state[state.auth.view].clients,
				organisation(state){
					const self = this;
					return state[state.auth.view].organisations.find( o => o.id == self.request.organisation )
				},
				contract(state){
					const self = this;
					return state[state.auth.view].contracts.find( o => o.id == self.request.contract )
				}
			}),
			deliverableColumns() {
				return 	[
					{type: "text", name: "Name", value: "name", rounded: true, filled: true, dense: true},
					{type: "text", name: "Quantity", value: "quantity" , rounded: true, filled: true, dense: true},
					{type: "date", name: "Date", value: "due", rounded: true, filled: true, dense: true},
					{type: "text", name: "Notes", value: "notes", rounded: true, filled: true, dense: true},
				]
			},
			additionalCostsColumns(){
				return 	[
					{type: "text", name: "Item", value: "name", rounded: true, filled: true, dense: true},
					{name: "Requested", value: "requested", type: "switch"},
					{type: "text", name: "Quantity", value: "n" , rounded: true, filled: true, dense: true},
					{type: "text", name: "CPU", value: "cpu", rounded: true, filled: true, dense: true},
					{type: "text", name: "Notes", value: "notes", rounded: true, filled: true, dense: true},
					{type: "automatic", name: "Total", value: "total", function: this.total },
				]
			},
			newProjectFields(){
				const request = this.request;
				let quotas = this.request.segments.map( r => r.title );
				return {
					request: request.id,
					quotas: quotas,
					internalName: request.title + " - " +  request.reference,
					clientName: request.title + " - " + request.clientReference,  
					participantName: request.title,
					users: request.users, 
					description: request.description, 
					dates: {
						startDate: request.startDate,
						endDate: request.endDate
					}
				}
			},
			submittingUser(){
				const self = this;
				if( !self.request.users ){ return; }
				let client = Object.keys(self.request.users).find( key => self.request.users[key] == 'client' );
				if( client ){
					let user = self.clients.find(c => c.id == client );
					if( user ){
						return user;
					}
					else{
						return false
					}
				}
				else{
					return false;
				}
			},
			segmentColumns(){
				let cols = [
					{
						value: "title",
						text: "Title",
						type: "text",
						inline: 1
					},
					{
						value: "sessionType",
						text: "Session Type",
						type: "text",
						inline: 1
					},
					{
						value: "numberOfSessions",
						text: "# of Sessions",
						number: true,
						type: "text",
						inline: 1
					},
					{
						value: "numberOfParticipants",
						text: "# of Participants / Session",
						number: true,
						type: "text",
						inline: 1
					},
					{
						value: "loi",
						text: "Length (mins)",
						number: true,
						type: "text",
						inline: 1
					},
					{
						value: "participantDescription",
						text: "Participant Description",
						type: "text",
						inline: 1
					},
				]
				if( this.contract ){
					this.contract.additionalFields.forEach( field => {
						var col = {
							value: field.name,
							text: field.description,
							type: field.type,
							rounded: true, 
							filled: true, 
							inline: 1
						}
						cols.push(col)
					})
				}
				cols.push({
					value: "desiredSchedule",
					text: "Desired Schedule / Times",
					type: "text",
					inline: 1
				});
				cols.push({
					value: "notes",
					text: "Notes",
					type: "text",
					inline: 1
				});
				cols.push({
					number: true,
					value: "recruitment",
					text: "Recruitment Cost",
					type: "text",
					"min-width": "150px",
					inline: 1
				});
				cols.push({
					type: "text",
					number: true,
					value: "incentive",
					text: "Incentive Cost",
					"min-width": "150px",
					inline: 1
				});

				cols.push({
					type: "button",
					value: "deleteSegment",
					text: "Delete",
					color: "red"
				});
				return cols;
			}			
		},
		watch: {
			request:{
				immediate: true,
				handler() {
					if( this.request.startDate ){
						this.request.startDate = Vue.moment(this.request.startDate.toDate()).format("YYYY-MM-DD")
					}
					if( this.request.endDate ){
						this.request.endDate = Vue.moment(this.request.endDate.toDate()).format("YYYY-MM-DD")
					}
				}
			},
			additionalCosts: {
				handler() {
					this.request.additionalCosts = this.additionalCosts;
				} 
			}
		},
		methods:{
			deleteSegment( item ){
				this.request.segments.splice( item.index, 1 )
			},
			addSegment(){
				this.request.segments.push( {} )
			},
			requestConverted(id){ 
				this.request.project = id;
				this.request.status = "project-started";
				this.dialog = false;
				this.saveRequest();
			},
			total(item){
				if( !item.n || !item.cpu ){ return 0; }
				return item.n * item.cpu;
			},
			alertClientQuote(){
				let message = {
					type: "quoteNotification", 
					recipient: this.submittingUser.id, 
					from: this.user.uid, 
					batch: false, 
					channel: "email", 
					sendStatus: "unsent",
					request: this.request.id
				}
				this.$store.dispatch("addDoc", {
					data: message, 
					collection: "contactEvents", 
				}).then( () => {
					this.$emit("saved")
				})

				// let newMessage = {
				// 	template: "quoteNotification", 
				// 	toUids: [this.submittingUser.id], 
				// 	data: {
				// 		fromName: this.user.displayName, 
				// 		requestTitle: this.request.title
				// 	}
				// }
				// this.$store.dispatch("addDoc", {
				// 	data: newMessage, 
				// 	collection: "sendMail", 
				// }).then( () => {
				// 	this.$emit("saved")
				// })

			},
			saveRequest(){
				let request = {...this.request};
				if( !request.users ){
					request.users = {}
				}
				this.mwContacts.forEach( id => {
					request.users[id] = "admin";
				})
				if( request.endDate ){
					request.endDate = formatDateTime(request.endDate, false )
				}
				if( request.startDate ){
					request.startDate = formatDateTime(request.startDate, false )
				}
				request.deliverables = [];
				this.deliverables.forEach( deliverable => {
					request.deliverables.push ({
						name: deliverable.name,
						quantity: deliverable.quantity,
						due: formatDateTime(deliverable.due, false ),
						notes: deliverable.notes
					})
				})
				this.$store.dispatch("updateDoc", {
					data: request, 
					doc: "requests/"+ request.id, 
					action: "update"
				}).then( () => {
					this.$emit("saved")
				})
			}
		},

		created(){
			if( !this.request.currency ){
				this.request.currency = "£";
			}
			if( this.request.additionalCosts ){
				this.additionalCosts = this.request.additionalCosts;
			}
			if( this.request.deliverables ){
				this.request.deliverables.forEach( deliverable => {
					if( deliverable.due ){
						deliverable.due = Vue.moment(deliverable.due.toDate()).format("YYYY-MM-DD")
					}
				})
				this.deliverables = this.request.deliverables
			}
			if( !this.request.reference ){
				this.request.reference = "MW" + this.request.id;
			}
			if( this.request.users ){
				this.mwContacts = Object.keys(this.request.users).filter( key => this.request.users[key] == 'admin' )
			}
			this.$store.dispatch("fetch", "admins")
			this.$store.dispatch("fetch", "clients")
		}
	}
	
</script>